import { noop } from "lodash";
import FavoriteTracksTemplate from "@tvg/atomic-ui/_templates/FavoriteTracks";

import GraphQuery from "../graphql/queries/TracksFavoritesQuery";
import RDAQuery from "../graphql/queries/TracksFavoritesRDAQuery";
import GraphOptions from "../graphql/resulted-tracks-favorites-options.graph";

export const getDerivedStateFromProps = () => ({
  firstRender: false,
  innerUpdate: false
});

export const skipQuery = ({
  isAccountCompliant,
  shouldUpdate,
  accountId,
  useRDAService
}) => useRDAService || !isAccountCompliant || !shouldUpdate || !accountId;

export const skipRDAQuery = ({
  isAccountCompliant,
  shouldUpdate,
  accountId,
  useRDAService
}) => !useRDAService || !isAccountCompliant || !shouldUpdate || !accountId;

const resultedTracksFavorite = {
  template: FavoriteTracksTemplate,
  query: GraphQuery,
  rdaQuery: RDAQuery,
  graphOptions: GraphOptions,
  skipQuery,
  skipRDAQuery,
  usesRDA: true,
  onlyUsesRDA: false,
  onlyFetchResultedTracks: true,
  renderTracksLetters: false,
  shouldComponentUpdate: noop,
  getDerivedStateFromProps
};

export default resultedTracksFavorite;
